const React = require("react");
const { brandConfig } = require("../../lib/brand_config");

const FAQFooter = (props) => {
  const supportEmail = brandConfig("supportEmail") || "support@bookastreetartist.com";
  return (
    <div className="b-payment__info">
      {I18n.t("payment_process.payment_method.any_questions_first")}
      &nbsp;<a target="_blank" href={props.faqPath} className="green-link" rel="noreferrer">FAQ</a>&nbsp;
      {I18n.t("payment_process.payment_method.any_questions_last")}
      &nbsp;
      <a href={`mailto:${supportEmail}`} className="green-link" target="_top">{supportEmail}</a>
    </div>
  );
};

module.exports = FAQFooter;
